
import { Options, Vue } from "vue-class-component";
import TagContainer from "./TagContainer.vue";
import ButtonShare from "./ButtonShare.vue";
import SharePopup from "./SharePopup.vue";

@Options({
  components: {
    TagContainer,
    ButtonShare,
    SharePopup,
  },
  props: {
    tagText: Array,
    eventTitle: String,
    country: String,
    origin: String,
  },
  data() {
    return {
      popup: false,
    };
  },
  methods: {
    togglePopup() {
      return !this.popup
        ? ((this.popup = true), this.$refs.sharepopup.focus())
        : (this.popup = false);
    },
    closePopup() {
      return (this.popup = false);
    },
  },
})
export default class EventGuestTitleBar extends Vue {
  eventTitle!: string;
  country!: string;
  origin!: string;
  tagText!: string[];
}
